// eslint-disable-next-line no-unused-vars
import style from "./Loader.scss";
import { usePromiseTracker } from "react-promise-tracker";

const Loader = ({ load }) => {
  const { promiseInProgress } = usePromiseTracker();

  return (
    <>
      {promiseInProgress || load ? (
        <div
          style={{
            cursor: "pointer",
            height: "100vh",
            width: "100vw",
            position: "fixed",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            left: 0,
            zIndex: "1200",
          }}
        >
          <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Loader;
